import axios from 'axios';

/**
 * get list
 */
export const getConfigList = data => axios.$callAPI(() => axios.get('configs/search', {params: data}));

/**
 * get AdInfo
 */
export const getConfigInfo = id => axios.$callAPI(() => axios.get('/configs/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('configs/' + id, data));
